module.exports = __webpack_public_path__ + "dashboard/img/radio_off.d437009ce5d052d69ffa25479ece0217.svg";